import ContactsListing from './ContactsListing';

export default ContactsListing;
